<template>
  <div class="bg-gray p-3">
    <div v-if="cart.staticMapUrl" class="mb-3 position-relative overflow-hidden ratio--4-3">
      <img
        :src="cart.staticMapUrl"
        alt=""
        class="img-fit absolute-center"
        loading="lazy"
      >

      <button
        type="button"
        class="btn btn--primary position-absolute left-1 bottom-1 shadow"
        data-action="click->map#onTogglerClick"
      >
        {{ i18n.viewOnMap }}
      </button>
    </div>

    <ul class="list-icons font-size-xxs mt-3">
      <li class="mb-1">
        <Icon name="night" extra-classes="color-text" /> {{ cart.periodDurationDays }} {{ i18n.days.toLocaleString() }}

        ({{ cart.periodDurationNights }} {{ i18n.nights.toLowerCase() }})
      </li>

      <li class="mb-1">
        <Icon name="user" extra-classes="color-text" /> {{ cart.maximumAmountOfPersons }} {{ i18n.persons.toLowerCase() }}
      </li>

      <li v-if="cart.formattedPeriod">
        <Icon name="calendar" extra-classes="color-text" /> {{ cart.formattedPeriod }}
      </li>
    </ul>

    <div class="mt-3">
      <div
        v-for="cartItem in cartItems"
        :key="cartItem.id"
        class="py-3 border-top-1 border-bottom-last-1"
      >
        <div class="color-text-dark font-size-xxs font-weight-semibold mb-1">
          {{ cartItem.title }}
        </div>

        <div class="font-size-xxs">
          {{ cartItem.amountOfNights }} {{ i18n.nights.toLowerCase() }}

          <span v-if="cartItem.dateOfArrival">
            &bull; {{ i18n.arrival }} {{ cartItem.dateOfArrival }}
          </span>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column">
      <button
        class="btn btn--primary btn--lg w-100"
        type="button"
        :disabled="!cartIsValid"
        @click="onCartStoreClick"
      >
        {{ i18n.continueBooking }}
      </button>

      <button
        type="button"
        class="btn btn--secondary flex-grow-1 mt-2"
        data-toggle="modal"
        data-target="#shareModal"
      >
        <Icon name="share" extra-classes="icon--lg mt-nudge-2 mr-2" /> {{ i18n.saveJourney }}
      </button>

      <button
        v-if="!cart.staticMapUrl"
        type="button"
        class="map-toggler btn btn--primary btn--lg w-100 mt-2"
        data-target="map.toggler"
        data-action="click->map#onTogglerClick"
        :data-text-map-closed="i18n.viewOnMap"
        :data-text-map-open="i18n.hideMap"
      >
        <Icon name="italy" extra-classes="icon--xl mr-2" />
        <Icon name="times" extra-classes="mr-2" />
        <span data-target="map.togglerText">{{ i18n.viewJourneyOnMap }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import formatPrice from '@/helpers/formatPrice';
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    cart: {
      type: Object,
      required: true,
    },

    cartItems: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters([
      'cartIsValid',
    ]),

    total() {
      return formatPrice(this.cart.total, 0, '€ ', '');
    },
  },

  methods: {
    ...mapActions([
      'storeCart',
    ]),

    onCartStoreClick() {
      this.storeCart(this.routes.address);
    },
  },
};
</script>
